import { mountHpEmbed } from './utils/mount-hp-embed.js';
mountHpEmbed('CA-6488').catch(console.error);
